import { HTTP_CODE } from '../../utils/redirector-utils';

export const isNotFound = ({ data }) => {
  if (data && !data?.layouts) {
    return {
      shouldRedirect: false,
      isErrorStatus: true,
      httpCode: HTTP_CODE.NOT_FOUND,
      description: 'Page not found'
    };
  }
  return null;
};

export const isLandingPageCanonical = ({ data, path }) => {
  let { canonicalURL } = data?.layouts?.seo || {};
  if (canonicalURL && path !== canonicalURL) {
    return {
      shouldRedirect: true,
      httpCode: HTTP_CODE.PERM_REDIRECT,
      redirectPath: canonicalURL,
      description: 'redirected for canonical'
    };
  }
  return null;
};